import type { EntryPoint } from '@/apilib';
import { EditorAPIKey, TabIndicationApiKey } from '@/apis';
import { createTabIndicationApi } from './tabIndicationState';

export const TabIndicationEntrypoint: EntryPoint = {
  name: 'TabIndicationApi',
  declareAPIs: () => [TabIndicationApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(TabIndicationApiKey, () =>
      createTabIndicationApi(shell),
    );
  },
};
